<div class="min-h-full" style="background-color:#fafaf7">

  @if (isLoading()) {
    <div class="flex items-center justify-center min-h-[60vh]">
      <div class="flex flex-col items-center gap-5">
        <div class="relative w-12 h-12">
          <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
          <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
        </div>
        <p class="text-stone-600 font-medium text-sm">Chargement…</p>
      </div>
    </div>
  }

  @if (!isLoading()) {
    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-6">

      @if (errorMessage()) {
        <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
          <span class="material-icons text-base text-red-500">error_outline</span>
          {{ errorMessage() }}
        </div>
      }

      <div class="bg-white rounded-3xl shadow-sm border border-stone-100 overflow-hidden">

        <!-- Filter bar -->
        <div class="px-6 py-4 border-b border-stone-100 flex items-center gap-3 flex-wrap">
          <select [value]="filterType()" (change)="filterType.set($any($event.target).value); onFilterChange()"
            class="border border-stone-200 text-stone-700 text-sm rounded-lg pl-3 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all bg-white">
            <option value="">Toutes les catégories</option>
            <option value="PARTP">Partenaires Principaux</option>
            <option value="PARTO">Partenaires Officiels</option>
          </select>
          <select [value]="filterStatus()" (change)="filterStatus.set($any($event.target).value); onFilterChange()"
            class="border border-stone-200 text-stone-700 text-sm rounded-lg pl-3 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all bg-white">
            <option value="">Tous les statuts</option>
            <option value="ACTI">En ligne</option>
            <option value="INAC">Hors ligne</option>
          </select>
          @if (permService.can('marketing', 'partenaires', 'create')) {
            <button type="button" (click)="openAddModal()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-xs font-medium flex-shrink-0 ml-auto">
              <span class="material-icons text-base">add</span>
              Ajouter un partenaire
            </button>
          }
        </div>

        <!-- Table -->
        <div class="overflow-x-auto">
          <table class="w-full text-sm" role="table">
            <thead>
              <tr class="border-b border-stone-100 bg-stone-50">
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-14">ID</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-14">Image</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider">Nom</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-28">Catégorie</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-24">Lien</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-28">Statut</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-stone-500 uppercase tracking-wider w-28">Actions</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-stone-50">

              @if (partenaires().length === 0) {
                <tr>
                  <td colspan="7" class="px-6 py-16 text-center">
                    <div class="flex flex-col items-center gap-3">
                      <div class="w-14 h-14 rounded-3xl bg-stone-100 flex items-center justify-center">
                        <span class="material-icons text-stone-300 text-2xl">handshake</span>
                      </div>
                      <p class="text-stone-500 text-sm font-medium">Aucun partenaire trouvé</p>
                      <p class="text-stone-400 text-xs">Ajoutez un partenaire via le bouton en haut</p>
                    </div>
                  </td>
                </tr>
              }

              @for (p of partenaires(); track p.id) {
                <tr class="hover:bg-stone-50 transition-colors duration-150"
                  [class.opacity-60]="p.status === 'INAC'">

                  <td class="px-4 py-3 w-14">
                    <span class="text-xs text-stone-400 font-mono">#{{ p.id }}</span>
                  </td>

                  <td class="px-4 py-3 w-14">
                    <div class="w-10 h-10 rounded-xl overflow-hidden bg-stone-100 flex items-center justify-center flex-shrink-0">
                      @if (p.file_link) {
                        <img [src]="p.file_link" [alt]="p.name" class="w-full h-full object-contain p-1" (error)="onImageError($event)" />
                      } @else {
                        <span class="material-icons text-stone-300 text-lg">image</span>
                      }
                    </div>
                  </td>

                  <td class="px-4 py-3">
                    <p class="font-semibold text-stone-800 text-xs truncate">{{ p.name }}</p>
                  </td>

                  <td class="px-4 py-3 w-28">
                    <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border whitespace-nowrap"
                      [class]="p.category === 'PARTP'
                        ? 'bg-amber-50 text-amber-700 border-amber-100'
                        : 'bg-primary-50 text-primary-700 border-primary-100'">
                      <span class="material-icons text-[10px]">{{ p.category === 'PARTP' ? 'star' : 'verified' }}</span>
                      {{ categoryLabel(p.category) }}
                    </span>
                  </td>

                  <td class="px-4 py-3 w-24">
                    @if (p.link_url) {
                      <a [href]="p.link_url" target="_blank" rel="noopener noreferrer"
                        class="inline-flex items-center gap-1 text-xs text-primary-600 hover:text-primary-800 font-medium transition-colors"
                        title="Visiter le site">
                        <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                        </svg>
                        Lire
                      </a>
                    } @else {
                      <span class="text-stone-300 text-xs">—</span>
                    }
                  </td>

                  <td class="px-4 py-3 w-28">
                    <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border whitespace-nowrap"
                      [class]="statusBadgeClass(p.status)">
                      <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                        [class]="p.status === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
                      {{ statusLabel(p.status) }}
                    </span>
                  </td>

                  <td class="px-4 py-3 w-28">
                    <div class="flex items-center justify-end gap-1">
                      <!-- Edit -->
                      @if (permService.can('marketing', 'partenaires', 'edit')) {
                        <button type="button"
                          class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-400 hover:bg-primary-50 hover:text-primary-600 transition-all"
                          (click)="openEditModal(p)" title="Modifier">
                          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z" />
                          </svg>
                        </button>
                      }
                      @if (permService.can('marketing', 'partenaires', 'status')) {
                        @if (p.status === 'INAC') {
                          <button type="button"
                            class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-400 hover:bg-emerald-50 hover:text-emerald-600 transition-all"
                            (click)="confirmStatus(p.id, 'ACTI')" title="Activer">
                            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                          </button>
                        } @else {
                          <button type="button"
                            class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-400 hover:bg-amber-50 hover:text-amber-600 transition-all"
                            (click)="confirmStatus(p.id, 'INAC')" title="Désactiver">
                            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                            </svg>
                          </button>
                        }
                      }
                    </div>
                  </td>

                </tr>
              }

            </tbody>
          </table>
        </div>
      </div>

    </div>
  }
</div>

<!-- Add modal -->
@if (addModal()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">

      <div class="flex items-center justify-between mb-5">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-2xl bg-primary-50 flex items-center justify-center flex-shrink-0">
            <span class="material-icons text-primary-500">handshake</span>
          </div>
          <div>
            <p class="font-semibold text-stone-800 text-sm">{{ isEditMode ? 'Modifier le partenaire' : 'Ajouter un partenaire' }}</p>
            <p class="text-xs text-stone-400 mt-0.5">Nom, catégorie et logo</p>
          </div>
        </div>
        <button type="button" (click)="closeAddModal()" class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-400 hover:bg-stone-100 transition-colors">
          <span class="material-icons text-base">close</span>
        </button>
      </div>

      <!-- Name -->
      <p class="text-xs font-medium text-stone-600 mb-1.5">Nom du partenaire <span class="text-red-500">*</span></p>
      <input type="text"
        [value]="addName()"
        (input)="addName.set($any($event.target).value)"
        placeholder="Ex: Fédération Royale Marocaine…"
        class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all mb-4" />

      <!-- Link URL -->
      <p class="text-xs font-medium text-stone-600 mb-1.5">Lien URL</p>
      <input type="url"
        [value]="addLinkUrl()"
        (input)="addLinkUrl.set($any($event.target).value)"
        placeholder="https://..."
        class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all mb-4" />

      <!-- Category -->
      <p class="text-xs font-medium text-stone-600 mb-2">Catégorie</p>
      <div class="flex gap-2 mb-4">
        <button type="button" (click)="addType.set('PARTP')"
          class="flex-1 flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl border text-sm font-medium transition-all"
          [class]="addType() === 'PARTP' ? 'bg-amber-50 border-amber-300 text-amber-700' : 'bg-white border-stone-200 text-stone-500 hover:border-stone-300'">
          <span class="material-icons text-base">star</span>
          Principal
        </button>
        <button type="button" (click)="addType.set('PARTO')"
          class="flex-1 flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl border text-sm font-medium transition-all"
          [class]="addType() === 'PARTO' ? 'bg-primary-50 border-primary-300 text-primary-700' : 'bg-white border-stone-200 text-stone-500 hover:border-stone-300'">
          <span class="material-icons text-base">verified</span>
          Officiel
        </button>
      </div>

      <!-- Logo (optional) -->
      <p class="text-xs font-medium text-stone-600 mb-2">Logo <span class="text-stone-400 font-normal">(optionnel)</span></p>
      <label class="relative flex flex-col items-center justify-center w-full border-2 border-dashed rounded-2xl cursor-pointer transition-all mb-4 overflow-hidden"
        [class]="addPreviewUrl() ? 'border-primary-300 h-32' : 'border-stone-200 hover:border-primary-300 hover:bg-primary-50/30 h-24'">
        @if (addPreviewUrl()) {
          <img [src]="addPreviewUrl()!" alt="preview" class="w-full h-full object-contain p-3" />
          <div class="absolute bottom-0 left-0 right-0 flex items-center justify-center gap-1.5 py-1.5 bg-white/80 backdrop-blur-sm text-[10px] text-stone-500">
            <span class="material-icons text-[12px]">edit</span>
            Cliquez pour changer
          </div>
        } @else {
          <span class="material-icons text-stone-300 text-3xl mb-1">cloud_upload</span>
          <span class="text-xs text-stone-400">Cliquez pour choisir une image</span>
          <span class="text-[10px] text-stone-300 mt-0.5">JPG, WEBP</span>
        }
        <input type="file" accept=".jpg,.jpeg,.webp" class="hidden" [disabled]="addUploading()" (change)="onImageSelected($event)" />
      </label>

      @if (addError()) {
        <p class="text-xs text-red-500 mb-3">{{ addError() }}</p>
      }

      <div class="flex gap-2 justify-end">
        <button type="button" (click)="closeAddModal()" [disabled]="addUploading()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors disabled:opacity-40">
          Annuler
        </button>
        <button type="button" (click)="submitAdd()" [disabled]="addUploading()"
          class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-xl hover:bg-primary-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
          @if (addUploading()) {
            <div class="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            Envoi…
          } @else {
            <span class="material-icons text-base">check</span>
            {{ isEditMode ? 'Enregistrer' : 'Ajouter' }}
          }
        </button>
      </div>

    </div>
  </div>
}

<!-- Confirmation modal -->
@if (pendingStatus()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        @if (pendingStatus()!.status === 'INAC') {
          <div class="w-10 h-10 rounded-2xl bg-amber-50 flex items-center justify-center flex-shrink-0">
            <svg class="w-5 h-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
            </svg>
          </div>
        } @else {
          <div class="w-10 h-10 rounded-2xl bg-emerald-50 flex items-center justify-center flex-shrink-0">
            <svg class="w-5 h-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
        }
        <div>
          <p class="font-semibold text-stone-800 text-sm">Confirmation</p>
          <p class="text-xs text-stone-500 mt-0.5">
            @if (pendingStatus()!.status === 'INAC') { Ce partenaire sera masqué du site public. }
            @else { Ce partenaire sera visible sur le site public. }
          </p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelStatus()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="applyStatus()"
          class="px-4 py-2 text-sm font-medium text-white rounded-xl transition-colors"
          [class]="pendingStatus()!.status === 'INAC' ? 'bg-amber-500 hover:bg-amber-600' : 'bg-emerald-600 hover:bg-emerald-700'">
          {{ pendingStatus()!.status === 'INAC' ? 'Désactiver' : 'Activer' }}
        </button>
      </div>
    </div>
  </div>
}
